import { type ComponentType, type ComponentProps } from 'react';

import { Link } from './i18n-navigation-link';

export type CustomLinkComponentProps = ComponentProps<typeof Link>;

export const withCustomLinkComponent = <T,>(Component: ComponentType<T>, props: T) => (
  <Component {...props} LinkComponent={Link} />
);
